import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakeGetResponder, createFakePostResponder } from '../test-utils';
import { createPhoneApi } from './';
export var createPhoneApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createPhoneApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenMakeCallFromTicket: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls")({ toNumber: dto.toNumber, ticketId: dto.ticketId });
        },
        whenGetPhoneNumbers: function () {
            return createFakeGetResponder(fakeHttp, '/twilio/admin/numbers');
        },
        whenGetToken: function () {
            return createFakeGetResponder(fakeHttp, '/tickets/phone/token');
        },
        whenTerminateCurrentCall: function (currentCallDto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + currentCallDto.ticketId + "/calls/" + currentCallDto.callId + "/terminate")({});
        },
        whenInviteAgentToCurrentCall: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/inviteAgent")({ invitedAgentId: dto.invitedAgentId });
        },
        whenAbortParticipantCall: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/participants/" + dto.invitedAgentId + "/abort")({});
        },
        whenHoldCurrentCall: function (currentCallDto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + currentCallDto.ticketId + "/calls/" + currentCallDto.callId + "/hold")({});
        },
        whenUnholdCurrentCall: function (currentCallDto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + currentCallDto.ticketId + "/calls/" + currentCallDto.callId + "/unhold")({});
        },
        whenMuteCurrentCaller: function (currentCallDto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + currentCallDto.ticketId + "/calls/" + currentCallDto.callId + "/mute")({});
        },
        whenUnmuteCurrentCaller: function (currentCallDto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + currentCallDto.ticketId + "/calls/" + currentCallDto.callId + "/unmute")({});
        },
        whenJoinCall: function (currentCallDto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + currentCallDto.ticketId + "/calls/" + currentCallDto.callId + "/listen")({});
        },
        whenGetCallCenterWorkerToken: function () {
            return createFakeGetResponder(fakeHttp, "/agents/callcenter/worker-token");
        },
        whenGetPhoneCall: function (getPhoneCallDto) {
            return createFakeGetResponder(fakeHttp, "/tickets/" + getPhoneCallDto.ticketId + "/calls/" + getPhoneCallDto.callId);
        },
        whenGetCallInvitationInfo: function (getCallInvitationDto) {
            return createFakeGetResponder(fakeHttp, "/tickets/call/invitation?invitationClientKey=" + getCallInvitationDto.invitationClientKey);
        },
        whenTransferCallToQueue: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/transfer")({});
        },
        whenWarmTransferCallToQueue: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.callId + "/transfer")({});
        },
        whenMakeCallFromTicketsList: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/phone/outbound")(dto);
        },
        whenGetIncomingCallData: function (key) {
            return createFakeGetResponder(fakeHttp, "/tickets/call/incomingClientCallData?incomingClientCallKey=" + key);
        },
        whenPausePhoneCallRecording: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.phoneCallId + "/pauseRecording")({});
        },
        whenResumePhoneCallRecording: function (dto) {
            return createFakePostResponder(fakeHttp, "/tickets/" + dto.ticketId + "/calls/" + dto.phoneCallId + "/resumeRecording")({});
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map